import { ClientEditForm } from "../../organisms/form/ClientEditForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useClientEdit } from "./hook";

export const ClientEditPage: React.FC = () => {
  const { client, handleCancel, handleEditClient } = useClientEdit();

  return (
    <MainTemplate title="顧客編集">
      {client && (
        <ClientEditForm
          client={client}
          onCancel={handleCancel}
          handleSubmit={handleEditClient}
        />
      )}
    </MainTemplate>
  );
};
